import { hexEq, type OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import { useMemo } from "react";
import type { Address } from "viem";
import { AddressSelector } from "./AddressSelector";

export interface MarketSelectorProps {
  sdk: OnchainSDK;
  curator: Address | undefined;
  value: Address | undefined;
  onChange: (market: Address | undefined) => void;
}

export const MarketSelector: FC<MarketSelectorProps> = props => {
  const { sdk, curator, value, onChange } = props;

  const markets = useMemo(() => {
    if (!curator) {
      return [];
    }
    return sdk.marketRegister.markets
      .filter(market => hexEq(market.configurator.address, curator))
      .map(market => ({
        address: market.pool.pool.address,
        name: market.pool.pool.name,
      }));
  }, [sdk, curator]);

  if (!curator) {
    return null;
  }

  return (
    <>
      <h4>Markets</h4>
      <AddressSelector items={markets} value={value} onChange={onChange} />
    </>
  );
};
